import * as React from "react"

function MuchBetter(props) {
  return (
    <svg
      width={19}
      height={17}
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6 12l-5 3a4 4 0 004 4h13a4 4 0 004-4V.5L18 3l-3.875 1L9 13l-3-1z"
        fill="url(#prefix__paint0_linear)"
      />
      <path
        d="M1 15l5-3 3 1 5.125-9L18 3l4-2.5"
        stroke="url(#prefix__paint1_linear)"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear"
          x1={12}
          y1={4}
          x2={12}
          y2={19}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3AFF6D" />
          <stop offset={1} stopColor="#6FCC87" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear"
          x1={11.5}
          y1={1.684}
          x2={11.5}
          y2={15}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3AFF6D" />
          <stop offset={1} stopColor="#6FCC87" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default MuchBetter
